// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/user_profile_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user_profile_background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  width: 100%;
}

.user_profile_details_main_container {
  height: auto !important;
  width: 300px;
  border-radius: 20px;
}
.user_profile_image_box {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  top: 0;
}
.user_profile_image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user_profile_details_background_theme {
  height: 100px;
  background-color: var(--background-theme-color);
  position: absolute;
}

.profile-card {
  width: 100%;
  min-height: 600px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  font-family: Arial, sans-serif;
  background-color: white;
}

.profile-header {
  background: var(--profile-gradient);
  padding: 7px;
  text-align: start;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100px;
}
.profile_header_box {
  width: 100%;
  text-align: start;
}
.user_profile_image_container {
  text-align: center;
  position: relative;
}
.profile-img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-top: 0px;
  border: 5px solid #fff;
  object-fit: cover;
}

.profile-body {
  margin-top: 40px;
  padding: 20px;
  text-align: center;
}

.profile-body h5 {
  margin: 30px 0;
  font-family: Lato;
  font-weight: 600;
}

.member-status {
  margin: 0;
}

.about-me {
  text-align: left;
  margin-top: 20px;
  font-family: Lato;
}
.about-me > h6 {
  margin: 0px;
  font-family: Lato;
  font-weight: 600;
}
.about-me > p {
  font-size: 10px;
  font-family: Lato;
  margin-top: 10px;
  min-height: 30px;
}

.contact-info {
  text-align: left;
  margin-top: 10px;
  font-weight: 600;
}
.contact-info > p,
.user_mobile_number_container > p {
  font-size: 10px;
  font-family: Lato;
  font-weight: 600;
}

.contact-info p {
  margin: 5px 0;
}

.profile-footer {
  background-color: transparent;
  padding: 10px;
  text-align: center;
}

.edit-button {
  background-color: var(--background-theme-color);
  color: #fff;
  border: none;
  height: auto;
  cursor: pointer;
  font-size: 10px;
}

.edit-button:hover {
  background-color: #140f2dad !important;
  color: white !important;
}
.profile_header {
  color: white;
  font-weight: 600;
  font-family: Lato;
}

.donations-card {
  width: 300px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  font-family: Arial, sans-serif;
  background-color: #fff;
}

.donations-header,
.bookmark_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}
.donations-header > #view-all {
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
}
.donations-header > #view-all:hover {
  text-decoration: underline;
}

.donations-header h6 {
  margin: 0;
  font-family: Lato;
}

.view-all {
  color: #3498db;
  text-decoration: none;
  font-size: 13px;
}

.donations-list {
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.donation-item {
  display: flex;
  justify-content: space-between;
  padding: 13px 0;
  border-bottom: 1px solid #ddd;
  width: 90%;
}
.donation-item > span {
  font-size: 13px;
}

.donation-item:last-child {
  border-bottom: none;
}

.bookmarks-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 300px;
  margin: 0 auto;
  text-align: center;
}

.bookmark {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
}

.bookmark-count {
  font-size: 3rem;
  font-weight: bold;
  cursor: pointer;
}

.bookmark-label {
  font-size: 12px;
  font-weight: 500;
  color: rgb(20, 15, 45);
  font-family: Lato;
}
.bookmark_body_container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 20px;
}

.bookmark_header > h6 {
  margin: 0px;
  font-family: Lato;
  font-weight: 600;
}
.user_dashboard_container {
  display: grid;
  grid-template-columns: 30% 30% 30%;
  width: 90%;
  column-gap: 40px;
  margin-top: 20px;
  margin-bottom: 20px;
  justify-content: center;
}
.user_dashboard_second_container,
.user_dashboard_third_container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#claims {
  height: 300px;
}

.empty_container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
#donations {
  height: 300px;
}
.user_dashboard_main_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
}
.user_mobile_number_container {
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
}

.user_name_input {
  width: 50%;
  border: 1px solid black;
  border-top-width: 0px;
  border-right-width: 0px;
  border-left-width: 0px;
  border-radius: 0px;
}
.user_name_input:hover,
.user_name_input:focus {
  border: 1px solid black;
  border-top-width: 0px;
  border-right-width: 0px;
  border-left-width: 0px;
  box-shadow: none !important;
  border-radius: 0px;
}

.user_profile_update_icons_container {
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
}
.user_profile_update_icons_container > #delete_icon {
  margin-top: 6px;
  cursor: pointer;
}
#upload_icon {
  size: 30px;
  cursor: pointer;
}

.bookmark-hover:hover > .bookmark-label {
  text-decoration: underline;
  cursor: pointer;
}

.book_mark_container {
  display: grid;
  row-gap: 20px;
  column-gap: 20px;
  justify-content: center;
}

.book_mark_container > .fact_category_wise_card_container {
  width: 100% !important;
}
.book_mark_laptop_main_container {

  padding-left: 20px;
  padding-right: 20px;
}
.bookmark_loading_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 20px;
}
.user_profile_contribution_fact_check {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 50px;
}
.tab_container {
  background-color: white;
  border-radius: 20px;
  padding: 20px;
}

.fact_check_create_form_footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.thumbnail_image_container > .ant-upload-list > .ant-upload {
  background-color: white !important;
}
.file_upload_button {
  border: 0;
  background-color: white;
}
.file_upload_button_text {
  margin-top: 8;
}

.ant-input-disabled,
.ant-select-disabled {
  background-color: white !important;
}
.form_title {
  color: white;
}

.user_donation_list {
  margin-top: 30px;
  background-color: white !important;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.bookmark_articles_container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 2%;

}
.profile_body_container {
  min-height: 250px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.empty_container_card {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.user_profile_contribution_fact_check,
.user_create_fact_check_form_container,
.user_create_article_form_container {
  padding: 50px;
}
.input_label {
  font-weight: 600;
}
.delete_body_container {
  display: flex;
  flex-direction: column;
  padding: 30px;
  gap: 50px;
}
.delete_body_container > text {
  font-weight: 600;
}
.user_donation_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 85%;
  padding: 7px;
}
.no_transaction_wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 7px;
}
.no_transaction_container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 85%;
}
.donate_button_disabled {
  cursor: not-allowed !important;
  background-color: #00adee !important;
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/user_profile.css"],"names":[],"mappings":"AAAA;EACE,yDAAuE;EACvE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;;AAEA;;EAEE,kCAAkC;AACpC;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;;AAEb;AACA;EACE,iBAAiB;;EAEjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;;EAGE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,uBAAuB;AACzB","sourcesContent":[".user_profile_background {\n  background-image: url(\"../../assets/icons/user_profile_background.png\");\n  background-size: cover;\n  width: 100%;\n}\n\n.user_profile_details_main_container {\n  height: auto !important;\n  width: 300px;\n  border-radius: 20px;\n}\n.user_profile_image_box {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  top: 0;\n}\n.user_profile_image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.user_profile_details_background_theme {\n  height: 100px;\n  background-color: var(--background-theme-color);\n  position: absolute;\n}\n\n.profile-card {\n  width: 100%;\n  min-height: 600px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  font-family: Arial, sans-serif;\n  background-color: white;\n}\n\n.profile-header {\n  background: var(--profile-gradient);\n  padding: 7px;\n  text-align: start;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100px;\n}\n.profile_header_box {\n  width: 100%;\n  text-align: start;\n}\n.user_profile_image_container {\n  text-align: center;\n  position: relative;\n}\n.profile-img {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  margin-top: 0px;\n  border: 5px solid #fff;\n  object-fit: cover;\n}\n\n.profile-body {\n  margin-top: 40px;\n  padding: 20px;\n  text-align: center;\n}\n\n.profile-body h5 {\n  margin: 30px 0;\n  font-family: Lato;\n  font-weight: 600;\n}\n\n.member-status {\n  margin: 0;\n}\n\n.about-me {\n  text-align: left;\n  margin-top: 20px;\n  font-family: Lato;\n}\n.about-me > h6 {\n  margin: 0px;\n  font-family: Lato;\n  font-weight: 600;\n}\n.about-me > p {\n  font-size: 10px;\n  font-family: Lato;\n  margin-top: 10px;\n  min-height: 30px;\n}\n\n.contact-info {\n  text-align: left;\n  margin-top: 10px;\n  font-weight: 600;\n}\n.contact-info > p,\n.user_mobile_number_container > p {\n  font-size: 10px;\n  font-family: Lato;\n  font-weight: 600;\n}\n\n.contact-info p {\n  margin: 5px 0;\n}\n\n.profile-footer {\n  background-color: transparent;\n  padding: 10px;\n  text-align: center;\n}\n\n.edit-button {\n  background-color: var(--background-theme-color);\n  color: #fff;\n  border: none;\n  height: auto;\n  cursor: pointer;\n  font-size: 10px;\n}\n\n.edit-button:hover {\n  background-color: #140f2dad !important;\n  color: white !important;\n}\n.profile_header {\n  color: white;\n  font-weight: 600;\n  font-family: Lato;\n}\n\n.donations-card {\n  width: 300px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n  font-family: Arial, sans-serif;\n  background-color: #fff;\n}\n\n.donations-header,\n.bookmark_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #ddd;\n}\n.donations-header > #view-all {\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 500;\n}\n.donations-header > #view-all:hover {\n  text-decoration: underline;\n}\n\n.donations-header h6 {\n  margin: 0;\n  font-family: Lato;\n}\n\n.view-all {\n  color: #3498db;\n  text-decoration: none;\n  font-size: 13px;\n}\n\n.donations-list {\n  padding: 10px 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.donation-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 13px 0;\n  border-bottom: 1px solid #ddd;\n  width: 90%;\n}\n.donation-item > span {\n  font-size: 13px;\n}\n\n.donation-item:last-child {\n  border-bottom: none;\n}\n\n.bookmarks-container {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  max-width: 300px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.bookmark {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: 10px 0;\n}\n\n.bookmark-count {\n  font-size: 3rem;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.bookmark-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: rgb(20, 15, 45);\n  font-family: Lato;\n}\n.bookmark_body_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  padding: 20px;\n}\n\n.bookmark_header > h6 {\n  margin: 0px;\n  font-family: Lato;\n  font-weight: 600;\n}\n.user_dashboard_container {\n  display: grid;\n  grid-template-columns: 30% 30% 30%;\n  width: 90%;\n  column-gap: 40px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  justify-content: center;\n}\n.user_dashboard_second_container,\n.user_dashboard_third_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n#claims {\n  height: 300px;\n}\n\n.empty_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n#donations {\n  height: 300px;\n}\n.user_dashboard_main_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  margin-bottom: 10px;\n}\n.user_mobile_number_container {\n  display: flex;\n  flex-direction: row;\n  gap: 2px;\n  align-items: center;\n}\n\n.user_name_input {\n  width: 50%;\n  border: 1px solid black;\n  border-top-width: 0px;\n  border-right-width: 0px;\n  border-left-width: 0px;\n  border-radius: 0px;\n}\n.user_name_input:hover,\n.user_name_input:focus {\n  border: 1px solid black;\n  border-top-width: 0px;\n  border-right-width: 0px;\n  border-left-width: 0px;\n  box-shadow: none !important;\n  border-radius: 0px;\n}\n\n.user_profile_update_icons_container {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  justify-content: center;\n}\n.user_profile_update_icons_container > #delete_icon {\n  margin-top: 6px;\n  cursor: pointer;\n}\n#upload_icon {\n  size: 30px;\n  cursor: pointer;\n}\n\n.bookmark-hover:hover > .bookmark-label {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.book_mark_container {\n  display: grid;\n  row-gap: 20px;\n  column-gap: 20px;\n  justify-content: center;\n}\n\n.book_mark_container > .fact_category_wise_card_container {\n  width: 100% !important;\n}\n.book_mark_laptop_main_container {\n\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.bookmark_loading_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-radius: 20px;\n}\n.user_profile_contribution_fact_check {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 50px;\n}\n.tab_container {\n  background-color: white;\n  border-radius: 20px;\n  padding: 20px;\n}\n\n.fact_check_create_form_footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.thumbnail_image_container > .ant-upload-list > .ant-upload {\n  background-color: white !important;\n}\n.file_upload_button {\n  border: 0;\n  background-color: white;\n}\n.file_upload_button_text {\n  margin-top: 8;\n}\n\n.ant-input-disabled,\n.ant-select-disabled {\n  background-color: white !important;\n}\n.form_title {\n  color: white;\n}\n\n.user_donation_list {\n  margin-top: 30px;\n  background-color: white !important;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.bookmark_articles_container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 2%;\n\n}\n.profile_body_container {\n  min-height: 250px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.empty_container_card {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.user_profile_contribution_fact_check,\n.user_create_fact_check_form_container,\n.user_create_article_form_container {\n  padding: 50px;\n}\n.input_label {\n  font-weight: 600;\n}\n.delete_body_container {\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n  gap: 50px;\n}\n.delete_body_container > text {\n  font-weight: 600;\n}\n.user_donation_container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 85%;\n  padding: 7px;\n}\n.no_transaction_wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 7px;\n}\n.no_transaction_container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 85%;\n}\n.donate_button_disabled {\n  cursor: not-allowed !important;\n  background-color: #00adee !important;\n  color: white !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
